import { render, staticRenderFns } from "./ChangePasswordStep.vue?vue&type=template&id=4278775a&"
import script from "./ChangePasswordStep.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports